import {useTranslation} from 'react-i18next';

import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import {Grid} from '@mui/material';

import {EmpionButton} from '../../../../../components/EmpionButton/EmpionButton';

export interface Props {
  isDocument: boolean;
  isGuided: boolean;
  isReviewStep: boolean;
  isUploadFormValid: boolean;
  canProceedGuided: boolean;
  isCreating: boolean;
  hasReviewIssues: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmitUpload: () => void;
  onSubmitGuided: () => void;
}

export const CreateWorkforceProfileModalActions = ({
  isDocument,
  isGuided,
  isReviewStep,
  isUploadFormValid,
  canProceedGuided,
  isCreating,
  hasReviewIssues,
  onBack,
  onNext,
  onSubmitUpload,
  onSubmitGuided,
}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.createModal'});
  const {t: tShared} = useTranslation();

  return (
    <Grid container spacing={1} justifyContent='flex-end' sx={{mt: 3, pt: 1}}>
      <Grid item>
        <EmpionButton variant='secondary' onClick={onBack}>
          {tShared('shared.formButtons.previous')}
        </EmpionButton>
      </Grid>
      {isDocument && (
        <Grid item>
          <EmpionButton
            variant='primary'
            disabled={!isUploadFormValid || isCreating}
            onClick={onSubmitUpload}
            startIcon={<AutoAwesomeOutlinedIcon />}
          >
            {t('generateProfile')}
          </EmpionButton>
        </Grid>
      )}
      {isGuided && !isReviewStep && (
        <Grid item>
          <EmpionButton variant='primary' disabled={!canProceedGuided} onClick={onNext}>
            {tShared('shared.formButtons.next')}
          </EmpionButton>
        </Grid>
      )}
      {isGuided && isReviewStep && (
        <Grid item>
          <EmpionButton
            variant='primary'
            disabled={hasReviewIssues || isCreating}
            onClick={onSubmitGuided}
            startIcon={<AutoAwesomeOutlinedIcon />}
          >
            {t('generateProfile')}
          </EmpionButton>
        </Grid>
      )}
    </Grid>
  );
};
